var map = {
	"./endless-runner.png": "b6f4",
	"./reaction-search.png": "b84a",
	"./remove-reddit-app-promos.png": "9670",
	"./roguelike.png": "d952",
	"./unity-number.png": "c900",
	"./vue-highcharts.png": "0cb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8583";